module.exports = __webpack_public_path__ + "static/media/compare_scan_view.cdcfbe77.png";